import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatLegacyTooltip as MatTooltip } from '@angular/material/legacy-tooltip';

import { MatIconModule } from '@angular/material/icon';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { CuttingStandardCutoutSlot, StandardCutoutAvailablePlates } from 'cloud-shared-lib';
import { GrooveTypeEnum } from '../../../../../../models/cutting/cutting-panel-base-slot.model';
import { PlateTypeEnum } from '../../../../../../models/cutting/cutting-panel-outline.model';
import { CuttingPanelSlot } from '../../../../../../models/cutting/cutting-panel-slot.model';
import { SidePosition } from '../groove-select.component';

@Component({
  selector: 'csl-groove-info',
  templateUrl: './groove-info.component.html',
  styleUrls: ['./groove-info.component.scss'],
  standalone: true,
  imports: [MatIconModule, MatTooltipModule],
  encapsulation: ViewEncapsulation.None,
})
export class GrooveInfoComponent implements OnInit {
  // svgText = '';
  position: SidePosition;
  groove: CuttingPanelSlot | CuttingStandardCutoutSlot;
  tooltipClass = '';
  matIconClassName: string;

  @Input() set data(val: {
    groove: CuttingPanelSlot | CuttingStandardCutoutSlot;
    position: SidePosition;
    matIconClassName?: string;
  }) {
    this.position = val.position;
    this.groove = val.groove;
    this.matIconClassName = val.matIconClassName;
  }

  @ViewChild('tooltip', { static: true }) tooltip: MatTooltip;

  constructor(private http: HttpClient) {}

  ngOnInit(): void {
    this.tooltipClass = 'custom-tt-' + this.position;
    this.tooltip.tooltipClass = this.tooltipClass + ' custom-tooltip';
  }

  private getImagePath(): string {
    let filePath = '';
    switch (this.groove.type) {
      case GrooveTypeEnum.Rabbet:
        filePath = 'assets/images/grooves/rabbet';
        break;

      case GrooveTypeEnum.InPlate:
        filePath = 'assets/images/grooves/in-plate';
        break;

      case GrooveTypeEnum.InSide:
        filePath = 'assets/images/grooves/in-side';
        break;

      case GrooveTypeEnum.Chamfer:
        filePath = 'assets/images/grooves/chamfer';
        break;

      case GrooveTypeEnum.Fillet:
        filePath = 'assets/images/grooves/fillet';
        break;

      case GrooveTypeEnum.Chamfer2:
        filePath = 'assets/images/grooves/chamfer2';
        break;
    }

    if (
      (this.groove instanceof CuttingPanelSlot && this.groove.plate === PlateTypeEnum.Back) ||
      (this.groove instanceof CuttingStandardCutoutSlot &&
        this.groove.availablePlates === StandardCutoutAvailablePlates.Back)
    ) {
      filePath += '-back';
    }

    filePath += '.svg';

    return filePath;
  }

  loadImage(): void {
    const svgNS = 'http://www.w3.org/2000/svg';

    if (!this.groove) {
      return;
    }

    const filePath = this.getImagePath();

    this.http.get(filePath, { responseType: 'text' }).subscribe(data => {
      const tooltipElement: Element = document.getElementsByClassName(this.tooltipClass)[0];

      if (tooltipElement) {
        const element = document.createElement('div');
        element.innerHTML = data;

        switch (this.groove.type) {
          case GrooveTypeEnum.InPlate:
          case GrooveTypeEnum.InSide:
          case GrooveTypeEnum.Rabbet:
            {
              const h = element.getElementsByClassName('h')[0] as SVGTextElement;
              h.textContent = this.groove.h.toString();

              const g = element.getElementsByClassName('g')[0] as SVGTextElement;
              g.textContent = this.groove.g.toString();

              if (this.groove.type === GrooveTypeEnum.InSide || this.groove.type === GrooveTypeEnum.InPlate) {
                const dx = element.getElementsByClassName('dx')[0] as SVGTextElement;
                dx.textContent = this.groove.dx.toString();
              }
            }
            break;

          case GrooveTypeEnum.Fillet:
            {
              const r = element.getElementsByClassName('r')[0] as SVGTextElement;
              r.textContent = this.groove.r.toString();
            }
            break;

          case GrooveTypeEnum.Chamfer2:
            {
              const b = element.getElementsByClassName('b')[0] as SVGTextElement;
              b.textContent = this.groove.b.toString();

              const dx = element.getElementsByClassName('dx')[0] as SVGTextElement;
              dx.textContent = this.groove.dx.toString();
            }
            break;

          case GrooveTypeEnum.Chamfer:
            {
              const fi = element.getElementsByClassName('fi')[0] as SVGTextElement;
              fi.textContent = this.groove.fi.toString();
            }
            break;
        }

        tooltipElement.textContent = '';
        tooltipElement.appendChild(element.children[0]);
      }
    });
  }
}
